// ClaudeCode: Main app — routing between login, lock, vault, and share redeem
import { useAuth } from './hooks/useAuth';
import { useAutoLock } from './hooks/useAutoLock';
import { LoginForm } from './components/LoginForm';
import { LockScreen } from './components/LockScreen';
import { VaultHome } from './pages/VaultHome';
import { ShareRedeem } from './pages/ShareRedeem';

export function App() {
  const auth = useAuth();

  // Auto-lock on idle (5 min)
  useAutoLock(auth.isUnlocked, auth.lock);

  // Share link redemption — public page, no auth
  const path = window.location.pathname;
  const shareMatch = path.match(/^\/share\/([a-f0-9-]+)$/);
  if (shareMatch) {
    return <ShareRedeem linkId={shareMatch[1]} />;
  }

  // Not authenticated — show login
  if (!auth.isAuthenticated) {
    return (
      <LoginForm
        onLogin={auth.login}
        onRegister={auth.register}
        onSsoLogin={auth.ssoLogin}
        ssoError={auth.ssoError}
      />
    );
  }

  // Authenticated but locked — show passphrase prompt
  if (!auth.isUnlocked || !auth.cryptoKey) {
    return (
      <LockScreen
        displayName={auth.user?.displayName ?? 'User'}
        isFirstTime={auth.isFirstTime}
        onUnlock={auth.unlock}
        onLogout={auth.logout}
      />
    );
  }

  // Unlocked — show vault
  return (
    <VaultHome
      cryptoKey={auth.cryptoKey}
      onLock={auth.lock}
      displayName={auth.user?.displayName ?? 'User'}
    />
  );
}
